export default __webpack_public_path__ + "static/media/abstract3.0c632498.jpeg";